module.exports = __webpack_public_path__ + "img/adi.e662f9aa.jpg";